export enum Role {
  User = 3,
  Admin = 2,
  SiteAdmin = 1
}
